export default {
  app: {
    env: process.env.NODE_ENV,
    url: "/poster-une-annonce/",
    admin_url: "/wp-admin/admin.php",
    gateway: "/wp-admin/admin-ajax.php",
  },
};
